import { SidebarItem } from "@/components/sidebar/types";
import { ChannelType, CHANNEL_TYPE } from "@/types/channel";

export const CHANNEL_SIDEBAR_CONFIG: Record<ChannelType, SidebarItem[]> = {
  [CHANNEL_TYPE.MESSENGER]: [
    {
      key: "messenger-configuration",
      href: "",
      icon: "solar:settings-bold",
      title: "Configuration",
    },
    {
      key: "messenger-posts",
      href: "posts",
      icon: "solar:gallery-bold",
      title: "Posts",
    },
    {
      key: "welcome-messages",
      href: "welcome-messages",
      icon: "solar:chat-round-dots-bold",
      title: "Welcome Messages",
    },
    {
      key: "persistent-menu",
      href: "persistent-menu",
      icon: "solar:hamburger-menu-bold",
      title: "Persistent Menu",
    },
  ],
  [CHANNEL_TYPE.WHATSAPP]: [
    {
      key: "whatsapp-configuration",
      href: "",
      icon: "solar:settings-bold",
      title: "Configuration",
    },
    {
      key: "whatsapp-profile",
      href: "whatsapp-profile",
      icon: "solar:user-id-bold",
      title: "Business Profile",
    },
    {
      key: "whatsapp-templates",
      href: "whatsapp-templates",
      icon: "solar:folder-with-files-bold",
      title: "Templates",
    },
  ],
  [CHANNEL_TYPE.TIKTOK]: [
    {
      key: "tiktok-configuration",
      href: "",
      icon: "solar:settings-bold",
      title: "Configuration",
    },
  ],
  [CHANNEL_TYPE.INSTAGRAM]: [
    {
      key: "instagram-configuration",
      href: "",
      icon: "solar:settings-bold",
      title: "Configuration",
    },
    {
      key: "instagram-feed",
      href: "instagram-feed",
      icon: "solar:gallery-bold",
      title: "Feed",
    },
    {
      key: "welcome-messages",
      href: "welcome-messages",
      icon: "solar:chat-round-dots-bold",
      title: "Welcome Messages",
    },
    {
      key: "persistent-menu",
      href: "persistent-menu",
      icon: "solar:hamburger-menu-bold",
      title: "Persistent Menu",
    },
  ],
  [CHANNEL_TYPE.PHONE]: [
    {
      key: "phone-configuration",
      href: "",
      icon: "solar:settings-bold",
      title: "Configuration",
    },
  ],
};
